"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Experian = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const baseLibrary_1 = require("../baseLibrary");
const EXPERIAN_URL = `${window.ASSETS_SERVER_PATH}/web/vendors/experian/prefs_ods.js`;
class MbExperian extends baseLibrary_1.BaseLibrary {
    async load() {
        try {
            this.instance = new web_ui_framework_1.Experian(EXPERIAN_URL);
            await this.instance.load();
        }
        catch (error) {
            web_ui_framework_1.Log.warn('Experian: There is not configured');
        }
    }
}
const Experian = new MbExperian();
exports.Experian = Experian;
//# sourceMappingURL=index.js.map